import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';

function Creategroup() {
    const [popup, setPopup] = useState(false);

    const [roomName , setRoomName] = useState('');
    const [roomInfo ,setRoomInfo] = useState('');
    const socket = useSelector(state => state.socket);

    const sendHandler = ()=>{
        console.log("create group send handler frontend calling the socket.emit(addgroup)")
        socket.emit('addgroup' , {name : roomName , info : roomInfo})
        setPopup(false);
        setRoomInfo('');
        setRoomName('');
    }

    let popup_content = <></>
    if (popup) {
        popup_content = (
            <div className="popup-container">
                <div className="popup">
                     <FontAwesomeIcon 
                     onClick = {()=>setPopup(false)}
                     className ="times-icon" icon={faTimes} />
                    <h1> Create New Room</h1>
                    <input 
                    value = {roomName}
                    onChange = {(e) => setRoomName(e.target.value)}
                    placeholder="Room Name.."></input>
                    <input
                    value = {roomInfo}
                    onChange = {(e) => setRoomInfo(e.target.value)}
                    placeholder="Room Info..."></input>
                    <button onClick = {sendHandler}>Create Room</button>
                </div>
            </div>
        )
    }

    return (
        <div className="add-group-button-container">
            {popup_content}
            <button
                onClick={() => setPopup(!popup)}
                className="add-group-button">Create Group<FontAwesomeIcon className="plus-icon" icon={faPlus} />
            </button>
        </div>
    )
}

export default Creategroup
